import { ReactNode } from 'react';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from 'src/common/components/DialogTitle';
import Loader from 'src/common/components/Loader';

interface EditorDialogShellProps extends Omit<DialogProps, 'title'> {
  id: string;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  contentSx?: DialogProps['sx'];
  isLoading?: boolean;
}

export default function EditorDialogShell({
  id,
  title,
  onClose,
  open,
  children,
  maxWidth = 'md',
  fullWidth = true,
  fullScreen,
  contentSx,
  isLoading,
  sx,
  slotProps,
  ...dialogProps
}: EditorDialogShellProps) {
  const handleClose = isLoading ? undefined : onClose;
  const paperSlotProps =
    typeof slotProps?.paper === 'object' && slotProps.paper !== null ? slotProps.paper : {};

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      aria-labelledby={`${id}-modal-title`}
      sx={sx}
      slotProps={{
        ...slotProps,
        paper: {
          ...paperSlotProps,
          sx: { position: 'relative', ...paperSlotProps.sx },
        },
      }}
      {...dialogProps}
    >
      {isLoading ? <Loader isLoading /> : null}
      <DialogTitle id={`${id}-modal-title`} onClose={onClose} closeDisabled={!!isLoading}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 1, ...contentSx }}>{children}</DialogContent>
    </Dialog>
  );
}
